__turbopack_context__.v({
  "actionBtn": "Toast-module-scss-module__Zikfeq__actionBtn",
  "actions": "Toast-module-scss-module__Zikfeq__actions",
  "close_button": "Toast-module-scss-module__Zikfeq__close_button",
  "description": "Toast-module-scss-module__Zikfeq__description",
  "error": "Toast-module-scss-module__Zikfeq__error",
  "hide": "Toast-module-scss-module__Zikfeq__hide",
  "icon": "Toast-module-scss-module__Zikfeq__icon",
  "info": "Toast-module-scss-module__Zikfeq__info",
  "manual": "Toast-module-scss-module__Zikfeq__manual",
  "slideIn": "Toast-module-scss-module__Zikfeq__slideIn",
  "success": "Toast-module-scss-module__Zikfeq__success",
  "title": "Toast-module-scss-module__Zikfeq__title",
  "toast": "Toast-module-scss-module__Zikfeq__toast",
});
